import { createSlice, createSelector } from '@reduxjs/toolkit'

// import { BASE_URL, OrganizationId, AuthToken } from '/features/storeconfig'



const initialState = {
    entities: {},
    status: 'idle', // idle loading success fail  
    error: null
}



const topicSlice = createSlice({
    name: 'topics',
    initialState,
    reducers: {
        topicAdd(state, action) {
            const topicData = action.payload
            state.entities[topicData.TopicId] = topicData
        },
        topicModify(state, action) {
            const topicData = action.payload
            state.entities[topicData.TopicId] = topicData
        } ,
        
        topicDelete(state, action) {
            const topicData = action.payload
            delete state.entities[topicData.TopicId]
        },
        topicHydrate(state, action) {
            const topicData = action.payload
            state.entities=topicData
            state.status = 'success'
        }
    }
}) 

export const { topicAdd, topicModify, topicDelete, topicHydrate, topicBranchingLogicModify } = topicSlice.actions

export default topicSlice.reducer

const selectTopicEntities = (state) => state.topics.entities

export const selectTopics = createSelector(selectTopicEntities, (entities) =>
    Object.values(entities)
)

export const selectTopicById = (state, TopicId) => {
    return selectTopicEntities(state)[TopicId]
}

